<template>
    <div>
        <div :class="['page loyalty',{ off: !pageOn }]">
            <VHeader type="back" @back="back" />
            <div class="page-content">  
                <p style="text-align: center;">Add Loyalty Reward</p>
                <div v-if="customer">
                    <p style="font-size: 22px;text-align: center;">{{ customer.name }}</p>
                    <p style="text-align: center;margin-top:20px;float:left;line-height: 30px;">Click on the number of cocktails the customer has purchased in this transaction</p>
                    <div style="width:100%;display:grid;grid-template-columns: 1fr 1fr 1fr;position: relative;top:-30px">
                        <p v-for="item in new Array(9).fill(true).map((_,i) => i+1)" :key="item" @click="awardQty(item)" class="btn-item">{{ item }}</p>
                    </div>
                    <p class="btn" @click="awardOther" style="line-height: 60px;margin-top: 10px;">Other Quantity</p>
                </div>
                <div v-if="!customer">
                    <div v-if="loyaltyCard">
                        <p style="font-size: 22px;text-align: center;">{{ customerName }}</p>
                        <img style="width: 80%;margin: 10px 0px 20px 10%" :src="loyaltyCard" />
                        <p class="btn big" @click="back">OK</p>
                    </div>
                    <div v-if="!loyaltyCard && cameraId">
                        <div id="scan-box" style="width: 100%;float:left"></div>
                        <canvas></canvas>
                    </div>
                    <p v-if="!loyaltyCard && cameraId" class="btn" @click="setValue({ k: 'cameraId', value: '' })">change camera</p>
                    <p v-if="!loyaltyCard && !cameraId" v-for="camera in cameras" class="btn" style="line-height: 90px;margin: 40px 15px;" @click="startScen(camera.id)">{{ camera.label }}</p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import Spinner from '@/components/Spinner.vue'

export default {
    name: 'loyalty',
    components: {
        VHeader,
        Spinner
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        cameraId() { return this.$store.state.cameraId },
        cameras () { return this.$store.state.cameras },
        client_id () { return this.$store.state.client_id },
        processedQuery () { return this.$store.state.processedQuery },
        query () { return this.$store.state.query }
    },
    watch: {
        auth ( auth ) {
            console.log('Loyalty watch.auth',auth);
            auth && this.checkQuery()
        }
    },
    data () {
        return {
            coupon: '',
            src: '',
            date: Date.now(),
            scanning: false,
            customer: false,
            html5QrcodeScanner: false,
            loyaltyCard: false,
            customerName: ''
        }
    },
    mounted () {
        //console.log('this.auth',this.auth);
        //console.log('this.query',this.query);
        if ( this.query ) return this.getLoyaltyCustomer(this.query);
        if ( !this.auth ) return this.pushPage('auth');
        if ( !this.$route.query.y && this.cameraId ) return this.startScen();
        if ( !this.$route.query.y ) return;
        !this.processedQuery && this.getLoyaltyCustomer(this.$route.query);

    },
    methods: {
        checkQuery () {
            if ( this.$route.query.y ) {
                this.getLoyaltyCustomer(this.$route.query);
            } else {
                this.cameraId && this.startScen();
            }
        },
        getLoyaltyCustomer ( query ) {
            WebSoc.SEND({ t: 'getLoyaltyCustomer', data: { auth: this.auth, query: query }},resp => {
                //console.log('getLoyaltyCustomer resp',resp);
                this.$router.replace('/');
                if ( resp.error ) return Alert.message(resp.error);
                var customer = resp.customer;
                if ( customer ) {
                    this.customer = customer;
                } 
                this.setValue({ k: 'processedQuery', v: true });   
                this.setValue({ k: 'query', v: false });              
            })
        },        
        startScen ( cameraId ) {
            if ( cameraId ) this.setValue({ k: 'cameraId', v: cameraId });
            this.$nextTick(() => {
                this.html5QrcodeScanner = new Html5Qrcode('scan-box',{},false);
                this.html5QrcodeScanner.start(this.cameraId,{ fps: 10, qrbox: 250 },this.getRedeem,e  => {});
            });
        },
        getRedeem ( msg ) {
            var query = msg.split('?')[1];
                if ( !query ) return;
                query = query.split('&').reduce((prev,fields) => { var fields = fields.split('=');  prev[fields[0]] = fields[1]; return prev; } ,{});
                this.html5QrcodeScanner.stop().then(_ => console.log('stopped')).catch(e => console.log('stop error',e));
                WebSoc.SEND({ t: 'getLoyaltyCustomer', data: { auth: this.auth, query: query } },resp => {
                    //console.log('getLoyaltyCustomer resp',resp);
                    if ( resp.error ) return Alert.message(resp.error);
                    var customer = resp.customer;
                    if ( customer ) {
                        this.customer = customer;
                    }  
                });           
        },
        back () {
            this.pageOn = false;
            this.html5QrcodeScanner && this.html5QrcodeScanner.stop().then(_ => console.log('stopped')).catch(e => console.log('stop error',e));
        },
        awardOther() {
            Alert.prompt('How many cocktails purchased in this transaction?',qty => {
                if ( isNaN(qty) ) return Alert.message('Invalid quantity');
                this.awardQty(qty);
                this.showLoyaltyCard(this.customer);
            })
        },
        awardQty ( qty ) {
            Alert.yesno('<span class="big-number">'+qty+'</span>Add to the customer loyalty card ?',yes => {
                if ( !yes ) return;
                this.applyAward(parseInt(qty));
                this.showLoyaltyCard(this.customer);
            })
        },
        showLoyaltyCard ( customer  ) {
            this.customer = false;
            this.customerName = customer.name;
            setTimeout(() => {
                this.loyaltyCard = 'https://api.survey-vip.com/loyalty/'+customer._id+'/'+customer.client_id+'?d='+Date.now(); //+'&transparent=true'
            },500);
        },
        applyAward ( qty ) {
            WebSoc.SEND({ t: 'awardCustomerLoyalty', data: { qty, customer_id: this.customer._id, auth: this.auth, client_id: this.auth.client_id  }},resp => {
                console.log('awardCustomerLoyalty resp',JSON.parse(JSON.stringify(resp)));
                if ( resp.update ) {    
                    this.date = Date.now(); 
                    Alert.message('Coupon Redeemed');
                }
                if ( resp.error ) Alert.message(resp.error);
            })
        },
        ...mapMutations(['setValue','pushPage'])
    }
}
</script>

<style lang="scss">
.big-number {
    font-size: 80px;
    width: 100%;
    float: left;
    line-height: 90px;
    margin-top: -20px;

}    
.btn-item {
    margin-top:50px !important;
    justify-self: center;
    font-size:40px;
    text-align: center;
    line-height: 70px;
    width:70px;
    background-color:#f4bd00;
    color:#424B5A;
    border-radius: 50%;
    &:active { transform: translate(2px, 2px); }
}
</style>